import { useGet, useQueryWithErrorHandling } from '@app/sdk';
import { Brand } from '@app/models';
import { brandBaseUrl } from '../BaseUrls';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";

export function useGetBrands() {
  const get = useGet(true, pillarCode);
  return useQueryWithErrorHandling({
    queryKey: ['get-brands'],
    queryFn: async () => await get<Brand[]>(`${brandBaseUrl}/brands`),
    enabled: true,
  });
}

export function useRefreshBrands() {
    const queryClient = useQueryClient();
    return async () => {
      await queryClient.invalidateQueries({ queryKey: ['get-brands'] });
    };
  }